// =============================================================================
// components/ui/Card.tsx — thin wrapper over GlassSurface (P0-A).
//
// Card is now a Glass Contract surface: it owns NO hardcoded rgba/hex — all
// translucency, border, sheen and elevation come from glass tokens via
// GlassSurface. Props stay backward-compatible (children/style/padding); the
// optional `variant`/`mode`/`onPress` are additive.
// =============================================================================
import React from 'react';
import { ViewStyle, StyleProp } from 'react-native';
import { radius as radiusTokens, spacing } from '../../constants/theme';
import GlassSurface from '../glass/GlassSurface';
import type { GlassVariant } from '../glass/tokens';

interface CardProps {
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  padding?: number;
  /** Glass surface variant. Default 'card'. */
  variant?: GlassVariant;
  /** Theme mode. 'light' (default) or 'dark' (voice/call). */
  mode?: 'light' | 'dark';
  /** Optional press handler — turns the card into a pressable glass surface. */
  onPress?: () => void;
}

export default function Card({
  children,
  style,
  padding = spacing.lg,
  variant = 'card',
  mode = 'light',
  onPress,
}: CardProps) {
  return (
    <GlassSurface
      variant={variant}
      mode={mode}
      radius={radiusTokens.lg}
      onPress={onPress}
      style={style}
      contentStyle={{ padding }}
    >
      {children}
    </GlassSurface>
  );
}
